
  window.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    let redirectTo = urlParams.get('checkout_url') || urlParams.get('redirectTo');
    const planInfo = urlParams.get('plan');

    const customerEmailInput = document.getElementById('CustomerEmail');
    const currentEmail = localStorage.getItem('currentEmail');

    if (currentEmail != null) {
      customerEmailInput.value = currentEmail;
    }

    if (redirectTo != null) {
      sessionStorage.removeItem('shopFlow')
      if (planInfo != null) {
        localStorage.setItem('redirectParam', redirectTo + `&plan=${planInfo}`);
        localStorage.setItem('returnTo', redirectTo + `&plan=${planInfo}`);
      } else {
        localStorage.setItem('redirectParam', redirectTo);
        localStorage.setItem('returnTo', redirectTo);
      }
    }

    //Social Network Treatment

    if (window?.navigator?.userAgent?.includes('Instagram')) {
      const googleLoginButton = document.getElementById('googleLoginButton');
      googleLoginButton?.remove();
    }

    const passwordInput = document.getElementById('CustomerPassword');

    if(passwordInput != null){
      passwordInput.value='';

      passwordInput.addEventListener('keydown', function(event) {
        const capsLockWarning = document.getElementById("capsLockWarning")
        if(event != null && event?.getModifierState != null){
          if (event.getModifierState('CapsLock')) {
            capsLockWarning.classList.remove('hidden');
          } else {
            capsLockWarning.classList.add('hidden');
          }
        }
      });
    }


  });

  function handleRefresh(){
    return window.location.reload();
  }

  function setCustomerEmail() {
    const emailInput = document.querySelector('#RecoverEmail');
    if (emailInput != null) {
      localStorage.setItem('currentEmail', emailInput.value);
    }
  }

  async function handleLogin() {
    const customerLoginButton = document.querySelector('.login-btn');
    const customerLoginForm = document.getElementById('customer_login');
    const customerEmailInput = document.getElementById('CustomerEmail');
    const customerPasswordInput = document.getElementById('CustomerPassword');

    if(customerLoginButton != null){
      customerLoginButton.innerHTML = "<span style='width: 20px; height:20px;' class='loader'></span>"
    }

    await fetch('/apps/proxy/create-customer-access-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: customerEmailInput.value,
        password: customerPasswordInput.value,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.customerAccessToken) {
          const currentDate = new Date();
          const expiringDate = new Date(data.expiresAt);
          const differenceInMilliseconds = expiringDate - currentDate;
          const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24));
          Cookies.set('customerAccessToken', data.customerAccessToken, {
            domain: 'caffeinearmy.com.br',
            expires: differenceInDays,
          });
        }

        customerLoginForm.submit();
      })
      .catch((err) => console.log(err));
  }
